<!-- 读卡点页面 -->
<template>
	<div class="fuzzy-matching-box">
		<!-- 读卡点页面 -->
		<div class="fuzzy-matching-top">
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="DEVICEID:">
						<el-input v-model="Dform.code" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="IMEI:">
						<el-input v-model="Dform.name" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="学校:">
						<el-input v-model="Dform.schoolName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
				</el-col>
				<el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
			</el-row>
			<el-row>
				<el-button type="text" class="text-button" @click="AddClick">新增读卡点</el-button>
				<el-button type="text" class="text-button" @click="SendFace">人脸同步校验下发</el-button>
				<el-button type="text" class="text-button" @click="Restart">设备重启</el-button>
			</el-row>
		</div>
		<div class="fuzzy-matching-bottom">
			<el-row class="list">
				<el-table stripe :border="true" v-loading="loading"
					:header-cell-style=" { background:'#EDF6FF',color:'#000',} " ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="schoolName" label="学校"></el-table-column>
					<el-table-column prop="name" label="名称"></el-table-column>
					<el-table-column prop="readOneCode" label="读卡器">
					</el-table-column>
					<el-table-column label='类型'>
						<template #default="scope">
							<span v-if="scope.row.type == 0">{{'单卡'}}</span>
							<span v-if="scope.row.type == 1">{{'双卡'}}</span>
							<span v-if="scope.row.type == 2">{{'D模式'}}</span>
							<span v-if="scope.row.type == 3">{{'13.56M'}}</span>
							<span v-if="scope.row.type == 4">{{'校车模式'}}</span>
							<span v-if="scope.row.type == 5">{{'人脸机-进'}}</span>
							<span v-if="scope.row.type == 6">{{'人脸机-出'}}</span>
						</template>
					</el-table-column>

					<el-table-column prop="readOneCode" label="设备地址"></el-table-column>
					<el-table-column prop="isOnline" label="设备状态">
						<template #default="scope">
							<span class="scope_grenn" v-if="scope.row.isOnline == '在线'">{{'在线'}}</span>
							<span class="scope_red" v-else>{{'离线'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="attendanceMsg" label="考勤信息" width="400"></el-table-column>
					<el-table-column prop="attendancePic" label="头像" width="100">
						<template #default="scope">
							<img class="head_img" src="../../../images/defult_man.jpeg" alt=""
								v-if="scope.row.attendancePic == null">
							<img class="head_img" :src="scope.row.attendancePic" alt=""
								@click="lookImage(scope.row.attendancePic)" v-else>
						</template>
					</el-table-column>

					<!-- <el-table-column label="T时间">
						<template #default="scope">
							<span v-if="scope.row.duration == 0">{{'无'}}</span>
						</template>
					</el-table-column>
					<el-table-column label="控制门禁">
						<template #default="scope">
							<span v-if="scope.row.checked == 1">{{'是'}}</span>
							<span v-if="scope.row.checked == 0">{{'否'}}</span>
						</template>
					</el-table-column> -->

					<el-table-column prop="loginTime" label="操作" width="250">
						<template #default="scope">
							<el-button class="textButton" type="text" size="small"
								@click="xiugaiClick(scope.row)">修改</el-button>
								<el-button class="shanchuBtn" type="text" size="small"
								@click="deleteClick(scope.row)">删除</el-button>
							<!-- <el-button class="textButton" type="text" size="small" @click="AddClick(scope.row)">添加读卡器</el-button> -->
							<el-button v-if="scope.row.readOneCode == null" class="textButton" type="text" size="small"
								@click="AdddukaqiClick(scope.row)">添加读卡点</el-button>
					
						</template>
					</el-table-column>
				</el-table>

				<div class="block-fenye">
					<el-pagination layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
				</div>
			</el-row>

		</div>
		<Add v-if="CardAddShow" @AddShowClick="AddShowClick" :xiugaiObj="xiugaiObj"></Add>
		<KaAdd v-if="tianjiaAdd" @backDkaqiClick="backDkaqiClick" :xinxiObj="xinxiObj"></KaAdd>
		<ImageView v-if="imageView" @addClick="addClick" :titleValue="titleValue" :pathPic="pathPic" />
	</div>
</template>

<script>
	import {
		readerCardPointList,
		readerCardPointDelete,
		readerCardAddInfo,
		rebootFaceDevice,
		batchIssuedFace
	} from '@/assets/api/schoollog';
	import {
		ElMessage
	} from 'element-plus'
	import Add from './Carderpoint/add.vue'
	import KaAdd from './dukaqiAdd/KaAdd.vue'
	import ImageView from '../checkguanli/ImageView.vue'

	export default {
		components: {
			Add,
			KaAdd,
			ImageView
		},
		data() {
			return {
				tianjiaAdd: false,
				CardAddShow: false,
				loading: true,
				Dform: {
					code: "",
					name: "",
					schoolName: "",
				},
				total: '',
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				selectList:[],
				tableData: [],
				xiugaiObj: {},
				xinxiObj: {},
				titleValue: '',
				imageView: false,
				pathPic: ""

			};
		},
		created() {
			this.readerCardPointListSearch()
		},
		mounted() {

		},
		methods: {
			//添加读卡器
			AdddukaqiClick(item) {
				this.xinxiObj = item
				this.tianjiaAdd = true
				// this.DukaqiEcho()
				// this.detailCard()


			},
			//添加读卡器返回
			backDkaqiClick() {
				this.tianjiaAdd = false
				this.readerCardPointListSearch()
			},

			//  掉读卡器数据
			DukaqiEcho() {
				const params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				readerCardAddInfo(params).then((res) => {
					console.log(res, 1111);
				}).catch((err) => {
					console.log(err, 222);
				})
			},
			//xiugaiClick修改
			xiugaiClick(imei) {
				// console.log(imei.readPointId,'修改');
				this.xiugaiObj = imei
				this.CardAddShow = true
			},
			// 新增
			AddClick() {
				this.CardAddShow = true

			},
			AddShowClick() {
				this.CardAddShow = false
				this.xiugaiObj = {}
				this.readerCardPointListSearch()
			},
			// 删除
			deleteClick(row) {
				const params = {
					id: row.readPointId
				}
				this.$confirm('请确认是否删除该读卡点!', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						readerCardPointDelete(params).then((res) => {
							ElMessage.success('删除成功')
							this.readerCardPointListSearch()
						})
					}).catch((err) => {
						console.log(err, '关机');
						this.$message({
							type: 'error',
							message: err.response.data.msg||'接口异常'
						});
					});
				

			},
			//列表
			readerCardPointListSearch() {
				const params = {
					schoolName: this.Dform.schoolName,
					code: this.Dform.code,
					name: this.Dform.name,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				readerCardPointList(params).then((res) => {
					console.log(res.data.data.list, '读卡点成功');
					this.tableData = res.data.data.list
					this.total = res.data.data.total
					this.loading = false

				}).catch((err) => {
					console.log(err, '校园公告失败');

				})
			},
			entrylogClick() {
				this.readerCardPointListSearch()
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.readerCardPointListSearch()
			},

			lookImage(file) {
				this.pathPic = file;
				this.titleValue = "读卡点头像";
				this.imageView = true;
			},

			addClick() {
				this.imageView = false
			},

			handleSelectionChange(val) {
				this.selectList = [];
				val.forEach((item,index)=> {
					const data = {};
					data.id = item.readPointId
					data.checked = item.checked
					data.duration = item.duration
					data.name = item.name
					data.readerOneId = item.readerOneId
					data.readerTwoId = item.readerTwoId
					data.schoolId = item.schoolId
					data.type = item.type
					this.selectList.push(data)
				})
			},
			
			SendFace(){
				if(this.selectList.length == 0){
					this.$message({
						message: "请勾选操作对象",
						type: 'error'
					});
					return;
				}
				
				this.$confirm('下发选中人脸, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					let data = {
						 pointEntities:this.selectList
					}
					
					batchIssuedFace(data).then((res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '操作成功！'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					}).catch((err) => {
						this.$message({
							message: err.message,
							type: 'error'
						});
					})
				}).catch(() => {
					// 取消操作
				});
			},
			
			Restart(){
				if(this.selectList.length == 0){
					this.$message({
						message: "请勾选操作对象",
						type: 'error'
					});
					return;
				}
				
				this.$confirm('重启选中设备, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let data = {
						 pointEntities:this.selectList
					}
					
					rebootFaceDevice(data).then((res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '操作成功！'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					}).catch((err) => {
						this.$message({
							message: err.message,
							type: 'error'
						});
					})
				}).catch(() => {
					// 取消操作
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 30px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 96%;
		background-color: #fff;
		border-radius: 8px;

		.title-top {
			padding: 20px 20px;
		}

		.fuzzy-matching-top {
			height: 100px;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				// justify-content: center 
				// justify-content: space-between
				justify-content: space-around;

				:deep() {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}
				}
			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 300px;
					padding: 16px 24px;
					// top: 50%;
					// transform: translate(0,-50%);
					// background-color: #1677FF;
				}
			}

			:deep() {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}

				.el-button--text {
					margin-left: 20px;
					font-size: 14px !important;
					margin-top: 15px;
					font-weight: 600;
					padding: 15px;
					color: #fff;
					background-color: #229CFA;
				}
			}

		}

		.fuzzy-matching-bottom {
			// position: absolute;
			padding: 20px;

			.textButton {
				margin: 0px !important;
				// padding: 10px;
				font-size: 15px !important;
				font-weight: 700;
			}

			.shanchuBtn {
				margin: 0px !important;
				// padding: 10px;
				font-size: 15px !important;
				font-weight: 700;
				color: red;
			}

			:deep() {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 15px;
					font-weight: 700;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					border: 0;
					font-size: 16px;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					// border: 0;
				}

				.el-button--text {
					// font-size: 16px !important;
				}
			}

			.scope_grenn {
				background-color: #b2ffc6;
				border: 1px solid #efefef;
				padding: 10px;
				color: green;
				border-radius: 10px;
			}

			.scope_red {
				background-color: #ffb6b7;
				border: 1px solid #efefef;
				padding: 10px;
				color: red;
				border-radius: 10px;
			}

			.head_img {
				max-width: 30px;
				max-height: 60px;
				object-fit: cover;
			}

			.block-fenye {
				margin-left: 1000px;
				margin-top: 15px;
			}
		}

	}
</style>